import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import * as React from "react";

import { User } from "../../models/User.model";
import FormProfil from "../FormProfil/FormProfil";
import Popin from "../Popin/Popin";
import { quotationFormStyles } from "../QuotationForm/QuotationForm.styles";

type PopinEditProfileProps = {
    open: boolean;
    user: User;
    onSubmit(user: User);
    onCancel();
};

class PopinEditProfile extends React.Component<PopinEditProfileProps & WithStyles<typeof quotationFormStyles>> {
    public onSubmit(user: User) {
        this.props.onSubmit(user);
        this.props.onCancel();
    }

    public render() {
        const { user } = this.props;

        return (
            <Popin open={this.props.open} maxWidth="sm" title="Modifier mon profil">
                <FormProfil defaultUser={user} onSubmit={this.onSubmit.bind(this)} onCancel={this.props.onCancel} />
            </Popin>
        );
    }
}

export default withStyles(quotationFormStyles)(PopinEditProfile);



// WEBPACK FOOTER //
// ./src/components/PopinEditProfile/PopinEditProfile.tsx